import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {useFormik} from 'formik';
import {useAuth} from '../../context/AuthContext';
import server from '../../global/server';
import Typography from '@mui/material/Typography';
import {useApp} from '../../context/AppContext';
import LoadingButton from '@mui/lab/LoadingButton';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import {useNavigate, useParams, useSearchParams} from 'react-router-dom';
import {useSnackbar} from 'notistack';
import * as Yup from 'yup';
import useHandleErrors from '../../hooks/useHandleErrors';
import {Avatar, Container, Stack} from '@mui/material';
import InputFile from '../../components/InputFile';

export default props => {
    const [search] = useSearchParams();
    const {verifySession, user} = useAuth();
    const {isOffline} = useApp();
    const [hasError, setError] = useState();
    useHandleErrors(hasError);

    const navigation = useNavigate();

    const RegisterSchema = Yup.object().shape({
        name: Yup.string().required('Campo obrigatório').max(50, 'Use no máximo 50 caracteres'),
        email: Yup.string().email('E-mail inválido').required('Campo obrigatório'),
    });

    const {enqueueSnackbar} = useSnackbar();
    const {
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleReset,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        setValues,
    } = useFormik({
        initialValues: {email: '', name: ''},
        validationSchema: RegisterSchema,
        onSubmit: async (values, {setSubmitting}) => {
            try {
                setSubmitting(true);

                const {data} = await server.put('account', values);
                enqueueSnackbar('Dados alterados.');
                verifySession();
                setSubmitting(false);
            } catch (error) {
                setSubmitting(false);

                setError(error);
            }
        },
    });

    useEffect(() => {
        if (user) {
            setValues(
                {
                    email: user.email,
                    name: user.name,
                    profile_image: user.profileImage,
                    preview_image: user.profileImage,
                },
                true,
            );
        }
    }, [user]);

    

    return (
        <Container maxWidth="xs" sx={{my: 4}}>
            <form onSubmit={handleSubmit}>
                <Grid container direction="column" gap={2}>
                    <Grid item xs={12}>
                        <Title>
                            <Typography variant="h6">Alterar conta</Typography>
                        </Title>
                    </Grid>
                    <Grid item xs={12} sx={{textAlign: 'center'}}>
                        <Stack alignItems="center">
                            <Avatar src={values.preview_image} sx={{width: 100, height: 100}} />
                        </Stack>
                        <InputFile
                            onChange={e => {  
                                setFieldValue('profile_image', e.base64);
                                setFieldValue('preview_image', e.preview);
                            }}
                            name="image"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            label="Nome completo"
                            type="text"
                            name="name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.name}
                            disabled={isOffline}
                            error={Boolean(errors.name)}
                            helperText={errors.name}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            label="E-mail"
                            type="text"
                            name="email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            error={Boolean(errors.email)}
                            disabled={isOffline}
                            helperText={errors.email}
                        />
                    </Grid>
                    {/* <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            label="Senha"
                            type="password"
                            name="password"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.password}
                            disabled={isOffline}
                            error={Boolean(errors.password)}
                            helperText={errors.password}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            label="Repita a Senha"
                            type="password"
                            name="repeat_password"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.repeat_password}
                            error={Boolean(errors.repeat_password)}
                            helperText={errors.repeat_password}
                            disabled={isOffline}
                        />
                    </Grid> */}
                    <Grid item xs={12}>
                        <LoadingButton
                            type="submit"
                            fullWidth
                            loading={isSubmitting}
                            variant="contained"
                            disabled={
                                Boolean(Object.keys(errors).length) || isSubmitting || isOffline
                            }>
                            Salvar dados
                        </LoadingButton>
                    </Grid>
                    {/* <Grid item xs={12}>
                        <LoadingButton
                            onClick={() => navigation(-1)}
                            fullWidth
                            variant="text"
                            disabled={isSubmitting}>
                            Voltar
                        </LoadingButton>
                    </Grid> */}
                </Grid>
            </form>
        </Container>
    );
};

const PanelAuth = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #eee;
`;

const BoxAuth = styled(Grid)`
    border: 1px solid #ccc;
    border-radius: 0.7rem;
    padding: 1.5rem;
    width: 350px;
    background: white;
`;

const Title = styled.div`
    text-align: center;
    margin-bottom: 20px;
`;

const BoxAuthContainer = styled.div`
    padding: 1px;
`;
